export default __webpack_public_path__ + "static/media/banner-image-2.43d94f79.svg";